(function (root, factory) {
    if (typeof define === "function" && define.amd) {
        define("prLocality", factory(root));
    } else if (typeof exports === "object") {
        module.exports = factory(root);
    } else {
        root.prLocality = factory(root);
    }
})(window || this, function (root) {

    "use strict";

    /**
     * Variables
     */

    const prLocality = {};

    let inputRuian, errorIcon, okIcon, emptyText, filterResult,
        locationItems = ['kraj', 'okres', 'obec', 'cobce', 'ulice', 'objekt', 'cisor_hod', 'cisor_pis', 'psc', 'mcast', 'pobvod', 'par_cis', 'par_cis_typ', 'par_cis_druh', 'ku', 'ku_kod'],
        locationItemsMap = {
            'kraj': 'VC_Nazev',
            'okres': 'OK_Nazev',
            'obec': 'OB_Nazev',
            'cobce': 'CO_Nazev',
            'ulice': 'UL_Nazev',
            'objekt': '',
            'cisor_hod': 'AD_CisloOrientacni',
            'cisor_pis': 'AD_CisloOrientacniPismeno',
            'psc': 'AD_Psc',
            'mcast': 'MC_Nazev',
            'pobvod': '',
            'par_cis': '',
            'par_cis_typ': '',
            'par_cis_druh': '',
            'ku': 'KU_Nazev',
            'ku_kod': 'AD_kod'
        },
        locationData = [],
        filter = false,
        values = {};

    const createValidIcon = (input) => {
        const prepend = document.createElement('div');
        prepend.classList.add('input-group-addon');
        prepend.style.borderRadius = '0';
        prepend.style.borderLeft = '0';

        errorIcon = document.createElement('i');
        errorIcon.classList.add('fa', 'fa-exclamation-circle', 'js-locality-valid-error');

        okIcon = document.createElement('i');
        okIcon.classList.add('fa', 'fa-check-circle', 'js-locality-valid-ok');
        okIcon.style.color = 'green';

        prepend.appendChild(errorIcon);
        prepend.appendChild(okIcon);

        // if (inputRuian.value === '')
        //     okIcon.style.display = 'none';
        // else errorIcon.style.display = 'none';

        if(input.classList.contains('js-locality-valid'))
            input.insertAdjacentElement('afterend', prepend);
    };

    const deleteForm = () => {
        errorIcon.style.color = 'red';
        errorIcon.style.display = 'block';

        okIcon.style.display = 'none';

        document.querySelectorAll('.js-locality-hidden').forEach((el) => { el.value = '' });
        inputRuian.value = '';
    };

    const generateForm = (input) => {
        if(document.querySelectorAll('.js-locality-hidden').length === 0){
            locationItems.forEach((item) => {
                const hiddenInput = document.createElement('input');
                hiddenInput.setAttribute('type', 'hidden');
                hiddenInput.setAttribute('name', item);
                hiddenInput.classList.add('js-locality-hidden', 'js-locality-' + item);
                hiddenInput.value = '';

                input.insertAdjacentElement('afterend', hiddenInput);
            });
        }

        const rozlohaInput = document.querySelector('#rozloha');
        if(typeof(rozlohaInput) !== 'undefined' && rozlohaInput !== null && !rozlohaInput.value)
            rozlohaInput.classList.add('not-edit');
    };

    const setDataToMultiForm = (input, item) => {
        if (!prLocality.options.multi)
            return;

        input.name = '';
        const onSuccess = (data) => {
            let localityItems = document.querySelector('.js-locality-items');
            if(typeof(localityItems) === 'undefined' || localityItems === null) {
                localityItems = document.createElement('div').classList.add('js-locality-items');
                input.insertAdjacentElement('beforebegin', localityItems);
            }

            const items = localityItems.querySelectorAll('.js-locality-item');
            const id = items.length !== 0 ? (parseInt(items[items.length - 1].dataset.id) + 1) : 0;

            const item = document.createElement('div');
            item.classList.add('js-lokality-item');
            item.dataset.id = id.toString();

            localityItems.appendChild(item);

            locationItems.forEach((input) => {
                const hiddenInput = document.createElement('input');
                hiddenInput.setAttribute('type', 'hidden');
                hiddenInput.setAttribute('name', 'lokalita['+ id +']['+ input +']');
                hiddenInput.value = data.location[input];

                item.appendChild(hiddenInput);
            });

            const hiddenInput = document.createElement('input');
            hiddenInput.setAttribute('type', 'hidden');
            hiddenInput.setAttribute('name', 'lokalita['+ id +'][ruian_kod]');
            hiddenInput.value = data.location['ruian_kod'];

            item.appendChild(hiddenInput);

            let title = '';
            if (data.location.okres)
                title = data.location.okres;
            if (data.location.obec)
                title += ', ' + data.location.obec;

            if (data.location.ulice) {
                title += ' ' + data.location.ulice;
                if (data.location.cisor_hod)
                    title += ' ' + data.location.cisor_hod;
            } else if (data.location.ku) {
                if (data.location.obec !== data.location.ku)
                    title += ' ' + data.location.ku;
                if (data.location.par_cis)
                    title += + ' ' + data.location.par_cis;
            }

            const deleteBtn = document.createElement('span');
            deleteBtn.classList.add('js-locality-item-delete');
            deleteBtn.innerHTML = '<i class="fa fa-times" aria-hidden="true"></i>';

            const titleEl = document.createElement('span');
            titleEl.classList.add('item-lokalita');
            titleEl.textContent = title;

            item.appendChild(titleEl);
            item.appendChild(deleteBtn);

            const wrapper = document.createElement('div').classList.add('item-lokalita-obal');
            item.parentNode.insertBefore(wrapper, item);
            wrapper.appendChild(item);

            deleteBtn.addEventListener('click', () => {
                const el = deleteBtn.closest('.js-locality-item');
                el.parentNode.removeChild(el);
            });
        }

        setRuianData(item, onSuccess);
    };

    const loadFormData = (values) => {
        const elements = document.querySelectorAll('.js-locality-hidden');
        Object.keys(values).forEach((key) => {
            elements.forEach((element) => {
                if(element.classList.contains('.js-locality-'+key))
                    element.value = values[key];
            });
        });
    };

    const setRuianData = (item, onSuccess) => {
        const apiData = {
            'ruian_kod': item.ruian_kod,
            'cid': window.setting.CID,
            'version': window.setting.VERSION,
            'locale': window.poskiLocale.locale,
            'hash': window.setting.API_HASH
        };

        let request = new XMLHttpRequest();
        request.open('GET', window.setting.API_URL+'/location/v1/get/?' + dataToQueryString(apiData), true);

        request.onload = function() {
            if (this.status >= 200 && this.status < 400)
                onSuccess(JSON.parse(this.response));
        };
        request.send();
    };

    const setDataToForm = (input, item) => {
        const onSuccess = (data) => {
            const elements = Array.from(document.querySelectorAll('.js-locality-hidden'));
            locationItems.forEach((item) => {
                const hiddenElement = elements.find(element => element.name === item);
                if (hiddenElement && data.location[item]) {
                    hiddenElement.value = data.location[item];
                }
            });

            inputRuian.value = data.location['ruian_kod'];

            errorIcon.style.display = 'none';
            okIcon.style.display = 'block';
            input.dispatchEvent(new CustomEvent('change-filter'));

            let rozlohaEl = document.querySelector('#rozloha');
            if(typeof(rozlohaEl) === 'undefined' || rozlohaEl === null)
                return;

            if(rozlohaEl.classList.contains('not-edit') || !rozlohaEl.value)
                rozlohaEl.value = rozlohaEl.value ? parseInt(rozlohaEl.value) + data.location.vymera : data.location.vymera
        };

        setRuianData(item, onSuccess);
    };

    prLocality.options = {
        multi: false
    }

    prLocality.init = (input, options) => {
        if(typeof(input) === 'undefined' || input === null)
            return;

        if (typeof options !== "undefined") {
            Object.keys(options).forEach((key) => {
                if (typeof prLocality.options[key] !== "undefined")
                    prLocality.options[key] = options[key];
            });
        }

        emptyText = input.dataset.localityEmptyText;
        filterResult = input.dataset.filterLocalityResult;
        filter = input.dataset.localityFilter === true;
        inputRuian = document.querySelector('input[name="ruian_kod"]');

        // nacteme defaultni hodnoty jsouli zadany
        if (input.dataset.localityElements) {
            locationItems = [];
            const localityElements = input.dataset.localityElements.split('|');
            localityElements.forEach(el => {
                const elParts = el.split(':');

                locationItems.push(elParts[0]);
                if(elParts[1])
                    values[elParts[0]] = elParts[1];
            });
        }

        generateForm(input);
        loadFormData(values);
        createValidIcon(input);

        let xhr;
        new autoComplete({
            selector: input,
            source: (term, response) => {
                const apiData = {};
                apiData['search'] = term;
                apiData['cid'] = window.setting.CID;
                apiData['version'] = window.setting.VERSION;
                apiData['locale'] = window.poskiLocale.locale;
                apiData['country'] = 'cz';
                apiData['label'] = filter ? 3 : 2;
                apiData['hash'] = window.setting.API_HASH;
                apiData['filter'] = JSON.stringify(filterResult);
                if (filter)
                    apiData['search_level'] = 'UL|CO|MC|OB|OK';

                if (xhr)
                    xhr.abort();

                const url = window.setting.API_URL+'/location/v1/search/?' + dataToQueryString(apiData);
                xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);

                xhr.onload = function() {
                    if (xhr.status < 200 && xhr.status >= 400)
                        return;

                    const data = JSON.parse(this.response);

                    const errors = input.parentNode.querySelector('.errors');
                    errors && errors.parentNode.removeChild(errors);
                    if (typeof data.locations === 'undefined' && typeof emptyText !== 'undefined') {
                        response({});
                        input.parentNode.insertAdjacentHTML('beforeend', '<div class="errors locale_"><div class="error">' + emptyText + '</div></div>');
                    } else {
                        response(data.locations);
                        locationData = data.locations;
                    }
                };
                xhr.send();

                deleteForm();
            },
            minChars: 2,
            onSelect: (e, term) => {
                e.preventDefault();
                const location = locationData.find(locality => locality.text_input === term);
                if (!location)
                    return;

                input.value = term;
                generateForm(input);
                setDataToMultiForm(input, location);
                setDataToForm(input, location);
                if (prLocality.options.multi)
                    input.value = '';
            }
        });

        document.querySelectorAll('.js-locality-item-delete').forEach(delBtn => {
            delBtn.addEventListener('click', el => {
                el.closest('.js-locality-item').parentNode().removeChild(el.closest('.js-locality-item'));
            });
        });

        const rozlohaEl = document.querySelector('#rozloha');
        rozlohaEl && rozlohaEl.addEventListener('change', function () {
            this.classList.remove('not-edit');
        });
    };

    return prLocality;
});